import { z } from "zod";

// Structure of posts should be:
// {
//   glossary: {
//     riskBands: "<UUID>",
//   }
// }
// Where "<UUID>" is the ID for the Document360 article.

export type CmsType = "article" | "category" | "link" | "text";
export const sectionTypes = ["grouped", "nested", "direct"] as const;
export type SectionType = (typeof sectionTypes)[number];

const postSectionsSchema: z.ZodType<any> = z.object({
  id: z.string(),
  type: z.string(),
  title: z.string().optional(),
  sectionType: z.enum(sectionTypes).optional(),
  items: z
    .record(
      z.string(),
      z.lazy(() => postSectionsSchema)
    )
    .optional(),
  link: z
    .object({
      url: z.string(),
      title: z.string(),
      isExternal: z.boolean().optional(),
    })
    .optional(),
});

export const postCategorySchema = z.record(z.string(), z.union([z.function().returns(z.string()), postSectionsSchema]));

export const postIdsSchema = z.object({
  glossary: postCategorySchema,
  guide: postCategorySchema,
  method: postCategorySchema,
  test: postCategorySchema,
  faqs: postCategorySchema,
});

export const postCategoryIdSchema = postIdsSchema.keyof();

export type PostCategoryId = z.infer<typeof postCategoryIdSchema>;
export type PostCategory = z.infer<typeof postCategorySchema>;
export type PostSection = z.infer<typeof postSectionsSchema>;

export type PostSchema = {
  id: string;
  type: CmsType;
  title?: string;
  sectionType?: SectionType;
  items?: Record<string, PostSchema>;
  link?: {
    url: string;
    title: string;
    isExternal?: boolean;
  };
};
export type PostIds = {
  glossary: Record<string, PostSchema>;
  guide: Record<string, PostSchema>;
  method: Record<string, PostSchema>;
  test: Record<string, PostSchema>;
  faqs: Record<string, PostSchema>;
};
